import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import { LocationIcon } from "../icons";

export default {
  options: {
    group: "config",
    accessible: ({ user }) =>
      user.role === "admin" && user.permissions.indexOf("location/list") !== -1,
  },
  icon: LocationIcon,
  list: List,
  edit: Edit,
  create: Create,
};
